import {
    AfterContentChecked,
    Directive,
    ElementRef,
    EventEmitter,
    HostBinding,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    inject
} from "@angular/core";
import MapView from "@arcgis/core/views/MapView";
import Draw from "@arcgis/core/views/draw/Draw";
import { Observable, ReplaySubject, Subject, of } from "rxjs";
import { IMapComponent } from "../../../map.models";
import { IMapDrawLayer, IMapSettings, IRenderParams, IWidgetMenuButton } from "../../../map.settings";

@Directive()

export abstract class MapBaseSubComponent implements OnChanges, AfterContentChecked, OnDestroy {
    buttons: IWidgetMenuButton[] = [];
    @Input() disabled: boolean;
    drawLayers: IMapDrawLayer[] = [];
    @Input() hideButton: boolean;
    isComponentEnabled = false;
    isVisible = false;
    mapReady = new EventEmitter<IMapComponent>();
    onElementReady: Observable<any>;
    onHide = new ReplaySubject<boolean>();
    onLayerRefresh = new EventEmitter<string>();
    onShow = new ReplaySubject<boolean>();
    refresh = new Subject<IRenderParams>();
    @HostBinding("attr.id") widgetId;

    protected readonly destroy$ = new Subject<void>();

    private readonly elementRef = inject(ElementRef);

    private targetElement: any;

    constructor() {
        this.onElementReady = of(this.elementRef.nativeElement);
        this.onElementReady.subscribe(e => this.targetElement = e);
    }

    get enabled() {
        return this.isComponentEnabled;
    }

    @Input()
    set enabled(value: boolean) {
        this.isComponentEnabled = value;
    }

    ngAfterContentChecked(): void {
        if (!this.targetElement) {
            return;
        }
        if (!this.isVisible && this.targetElement.offsetParent != null) {
            this.isVisible = true;
            this.onShow.next(true);
        } else if (this.isVisible && this.targetElement.offsetParent == null) {
            this.onHide.next(true);
            this.isVisible = false;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.disabled?.previousValue !== changes.disabled?.currentValue) {
            this.buttons?.forEach(b => {
                b.disabled = changes.disabled?.currentValue;
            });
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onInit(view: MapView, draw: Draw) {
        // Tom init
    }

    preInit(mapsettings: IMapSettings) {
        // Tom preinit
    }

    refreshLayers() {
        this.drawLayers.forEach(l => {
            this.refresh.next({ layerId: l.id });
        });
    }
}
